<ngx-json-ld [json]="schema "></ngx-json-ld>
<app-header></app-header>
<div class="container-fluid p-0 main-content">

  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
